module.exports = __webpack_public_path__ + "static/img/banner4.4d9e06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner4.png
// module id = oXVe
// module chunks = 0